import React from 'react';
import { useParams } from 'react-router-dom';
import './Page.css';
import './UniformCode.css';

const Academics = () => {
  const { subpage } = useParams();
  

  // Uniform images
  const mShirt = '/assets/uniforms/maroonShirt.jpg';
  const mPant = '/assets/uniforms/maroonPant.jpg';
  const mTunic = '/assets/uniforms/maroonTunic.jpeg';
  const wShirt = '/assets/uniforms/whiteShirt.jpg';
  const wPant = '/assets/uniforms/whitePant.jpg';
  const wTunic = '/assets/uniforms/whiteTunic.jpg';
  const sweater = '/assets/uniforms/sweater.jpg';

  if (subpage === 'uniform-code') {
    return (
      <div className="page-container">
        <div className="page-header">
          <h1>Uniform Code</h1>
        </div>
        <div className="page-content">
          <div className="uniform_section">
            <h2>Monday, Tuesday, Wednesday, Friday, Saturday</h2>
            <section className="uniform_main">
              <div className="uniform_main_img">
                <div>
                  <img src={mShirt} alt='Maroon Shirt' />
                </div>
                <div>
                  <img src={mPant} alt='Maroon Pant' />
                </div>
                <div>
                  <img src={sweater} alt='Sweater' />
                </div>
              </div>
              <div className="uniform_main_content">
                <h3 className="uniform_title">For Boys:</h3>
                <ul>
                  <li>Full Sleeves White Maroon Checks Shirt</li>
                  <li>Maroon Full Pants</li>
                  <li>School Tie</li>
                  <li>Black Socks</li>
                  <li>Black Shoes</li>
                  <li>Maroon Sweater (Winter)</li>
                </ul>
              </div>
            </section>
            <section className="uniform_main uniform_main_even">
              <div className="uniform_main_content">
                <h3 className="uniform_title">For Girls:</h3>
                <ul>
                  <li>Full Sleeves White Maroon Checks Shirt</li>
                  <li>Maroon Tunic</li>
                  <li>School Tie</li>
                  <li>Black Socks</li>
                  <li>Black Shoes</li>
                  <li>Maroon Sweater (Winter)</li>
                </ul>
              </div>
              <div className="uniform_main_img">
                <div>
                  <img src={mShirt} alt='Maroon Shirt' />
                </div>
                <div>
                  <img src={mTunic} alt='Maroon Tunic' />
                </div>
                <div>
                  <img src={sweater} alt='Sweater' />
                </div>
              </div>
            </section>
          </div>
          <div className="uniform_section">
            <h2>Thursday</h2>
            <section className="uniform_main">
              <div className="uniform_main_img">
                <div>
                  <img src={wShirt} alt='White Shirt' />
                </div>
                <div>
                  <img src={wPant} alt='White Pant' />
                </div>
                <div>
                  <img src={sweater} alt='Sweater' />
                </div>
              </div>
              <div className="uniform_main_content">
                <h3 className="uniform_title">For Boys:</h3>
                <ul>
                  <li>Full Sleeves White Shirt</li>
                  <li>White Full Pants</li>
                  <li>School Tie</li>
                  <li>White Socks</li>
                  <li>White Shoes</li>
                  <li>Maroon Sweater (Winter)</li>
                </ul>
              </div>
            </section>
            <section className="uniform_main uniform_main_even mb-5">
              <div className="uniform_main_content">
                <h3 className="uniform_title">For Girls:</h3>
                <ul>
                  <li>Full Sleeves White Shirt</li>
                  <li>White Tunic</li>
                  <li>School Tie</li>
                  <li>White Socks</li>
                  <li>White Shoes</li>
                  <li>Maroon Sweater (Winter)</li>
                </ul>
              </div>
              <div className="uniform_main_img">
                <div>
                  <img src={wShirt} alt='White Shirt' />
                </div>
                <div>
                  <img src={wTunic} alt='White Tunic' />
                </div>
                <div>
                  <img src={sweater} alt='Sweater' />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }

  if (subpage === 'school-timings') {
    return (
      <div className="page-container">
        <div className="page-header">
          <h1>School Timings</h1>
        </div>
        <div className="page-content">
          <div className="timings-container">
            <div className="timing-item">
              <h2>School Timings</h2>
              <p>Monday to Saturday - 11:00 AM to 04:00 PM</p>
            </div>
            <div className="timing-item">
              <h2>Office Timing</h2>
              <p>Monday to Friday - 11:30 AM to 03:00 PM</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (subpage === 'fee-structure') {
    return (
      <div className="page-container">
        <div className="page-header">
          <h1>Fee Structure — Session 2026–27</h1>
        </div>
        <div className="page-content">
          <div className="table-container">
            <div style={{marginBottom: "15px", color: "red"}}>Note: Admission fee is payable at the time of new admission only.</div>
            <table className="data-table">
              <thead>
                <tr>
                  <th>S.N.</th>
                  <th>Class</th>
                  <th>Tuition Fee</th>
                  <th>Exam Fee</th>
                  <th>Other Fee</th>
                  <th>Admission Fee</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>1</strong></td>
                  <td>Nursery</td>
                  <td>₹5000</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹10500</strong></td>
                </tr>
                <tr>
                  <td><strong>2</strong></td>
                  <td>L.K.G.</td>
                  <td>₹5000</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹10500</strong></td>
                </tr>
                <tr>
                  <td><strong>3</strong></td>
                  <td>U.K.G.</td>
                  <td>₹5000</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹10500</strong></td>
                </tr>
                <tr>
                  <td><strong>4</strong></td>
                  <td>1st</td>
                  <td>₹5000</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹10500</strong></td>
                </tr>
                <tr>
                  <td><strong>5</strong></td>
                  <td>2nd</td>
                  <td>₹5000</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹10500</strong></td>
                </tr>
                <tr>
                  <td><strong>6</strong></td>
                  <td>3rd</td>
                  <td>₹5000</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹10500</strong></td>
                </tr>
                <tr>
                  <td><strong>7</strong></td>
                  <td>4th</td>
                  <td>₹5000</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹10500</strong></td>
                </tr>
                <tr>
                  <td><strong>8</strong></td>
                  <td>5th</td>
                  <td>₹5000</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹10500</strong></td>
                </tr>
                <tr>
                  <td><strong>9</strong></td>
                  <td>6th</td>
                  <td>₹5500</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹11000</strong></td>
                </tr>
                <tr>
                  <td><strong>10</strong></td>
                  <td>7th</td>
                  <td>₹5500</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹11000</strong></td>
                </tr>
                <tr>
                  <td><strong>11</strong></td>
                  <td>8th</td>
                  <td>₹5500</td>
                  <td>₹500</td>
                  <td>₹1500</td>
                  <td>₹3500</td>
                  <td><strong>₹11000</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  if (subpage === 'books') {
    return (
      <div className="page-container">
        <div className="page-header">
          <h1>List of Books Required for Academic Session 2025-26</h1>
        </div>
        <div className="page-content">
          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Class</th>
                  <th>Government Books</th>
                  <th>Other Books</th>
                  <th>Publisher</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Nursery</strong></td>
                  <td>N/A</td>
                  <td><em>All-in-One Reading & Writing</em></td>
                  <td>Suman Publication</td>
                  <td>₹895</td>
                </tr>
                <tr>
                  <td><strong>L.K.G.</strong></td>
                  <td>N/A</td>
                  <td><em>All-in-One Reading & Writing</em></td>
                  <td>Suman Publication</td>
                  <td>₹945</td>
                </tr>
                <tr>
                  <td><strong>U.K.G.</strong></td>
                  <td>N/A</td>
                  <td><em>All-in-One Reading & Writing</em></td>
                  <td>Suman Publication</td>
                  <td>₹995</td>
                </tr>
                <tr>
                  <td><strong>Class I</strong></td>
                  <td>As per Board</td>
                  <td>Merri Gold Semester I & II</td>
                  <td>Promise Education Publication</td>
                  <td>₹890</td>
                </tr>
                <tr>
                  <td><strong>Class II</strong></td>
                  <td>As per Board</td>
                  <td>Merri Gold Semester I & II</td>
                  <td>Promise Education Publication</td>
                  <td>₹990</td>
                </tr>
                <tr>
                  <td><strong>Class III</strong></td>
                  <td>As per Board</td>
                  <td>Merri Gold Semester I & II</td>
                  <td>Promise Education Publication</td>
                  <td>₹1150</td>
                </tr>
                <tr>
                  <td><strong>Class IV</strong></td>
                  <td>As per Board</td>
                  <td>Merri Gold Semester I & II</td>
                  <td>Promise Education Publication</td>
                  <td>₹1290</td>
                </tr>
                <tr>
                  <td><strong>Class V</strong></td>
                  <td>As per Board</td>
                  <td><em>Hindi Grammar</em>, <em>English Grammar</em>, <em>GK</em>, <em>Computer</em></td>
                  <td>Focus Learning Publication</td>
                  <td>305 + 240 + 295 + 300 = <strong>₹1140 total</strong></td>
                </tr>
                <tr>
                  <td><strong>Class VI</strong></td>
                  <td>As per Board</td>
                  <td><em>Hindi Grammar</em>, <em>English Grammar</em>, <em>GK</em>, <em>Computer</em></td>
                  <td>Focus Learning Publication</td>
                  <td>315 + 250 + 305 + 315 = <strong>₹1170 total</strong></td>
                </tr>
                <tr>
                  <td><strong>Class VII</strong></td>
                  <td>As per Board</td>
                  <td><em>Hindi Grammar</em>, <em>English Grammar</em>, <em>GK</em>, <em>Computer</em></td>
                  <td>Focus Learning Publication</td>
                  <td>325 + 260 + 320 + 325 = <strong>₹1230 total</strong></td>
                </tr>
                <tr>
                  <td><strong>Class VIII</strong></td>
                  <td>As per Board</td>
                  <td><em>Hindi Grammar</em>, <em>English Grammar</em>, <em>GK</em>, <em>Computer</em></td>
                  <td>Focus Learning Publication</td>
                  <td>340 + 270 + 325 + 340 = <strong>₹1275</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  const pageContent = {
    'admission': {
      title: 'Admission',
      content: 'Content for Admission will be added here.'
    },
    'result': {
      title: 'Result',
      content: 'Content for Result will be added here.'
    }
  };

  const currentPage = pageContent[subpage] || {
    title: 'Academics',
    content: 'Please select a section from the Academics menu.'
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>{currentPage.title}</h1>
      </div>
      <div className="page-content">
        <p>{currentPage.content}</p>
      </div>
    </div>
  );
};

export default Academics;

